import React from 'react'
import { getLoginUrl } from 'chemistry'

export const BricoPlusBanner = props => {
  const { praxisPlusText, format, lang } = props
  const { loginLinkText, title, text } = praxisPlusText

  const onClick = () => {
    window.location.href = getLoginUrl({ format, lang })
  }

  return (
    <div className='mxd-praxis-plus-banner gap-1 rounded'>
      <div className='mxd-praxis-plus-banner-logo flex justify-center items-center circle relative'>
        <img
          style={{ maxWidth: '64px' }}
          src='https://images.ctfassets.net/0nvfg2ncafkj/6Nd2NtFKvOqIqxEbl216uR/aecb6963dc2bd5cb45f934de229954f6/mijn-brico-large.png'
          alt='Brico card'
        />
      </div>
      <div className='flex flex-column justify-center flex-wrap gap-half'>
        <h3 className='h3'>{title}</h3>
        <div className='h4 flex gap-half'>
          {loginLinkText && (
            <span className='mxd-praxis-plus-banner-link' onClick={onClick}>
              {loginLinkText}
            </span>
          )}
          {text && <span>{text}</span>}
        </div>
      </div>
    </div>
  )
}
